export const createFormDataReducer = (state, action) => {
  const { buttons = [], fields = [] } = action

  // set buttonId to null as default value or to default value from buttons array
  let buttonId = null
  if (buttons.length) {
    const defaultButton = (buttons || []).find(button => {
      return button.defaultButton === true
    }) || buttons[0]
    buttonId = defaultButton.id
  }

  // create formData for field inputs
  const formInputs = (fields || []).reduce((data, field) => {
    const { id, defaultValue } = field
    data[id] = defaultValue
    return data
  }, {})

  const formData = {
    buttonId,
    ...formInputs,
  }

  return {
    ...state,
    formData,
  }
}

export default createFormDataReducer
